<template>
	<!-- 添加/编辑菜单弹窗 -->
	<u-dialog :title="$t('project.txt1')" :visible.sync="myVisible" width="800px" top="50px" @confirm="confirm">
		<el-table ref="table" v-loading="loading" :data="dataList" max-height="600px" :highlight-current-row="true" @row-click="rowClick">
            <el-table-column label="" width="50">
                <template slot-scope="scope">
                    <el-radio v-model="currentRow.id" :label="scope.row.id"> </el-radio>
                </template>
            </el-table-column>
			<el-table-column prop="projectName" :label="$t('project.txt2')"></el-table-column>
			<el-table-column prop="projectDescribe" :label="$t('project.txt3')"></el-table-column>
			<el-table-column prop="timeStr" :label="$t('project.txt4')"></el-table-column>
		</el-table>
		<pagination v-show="total>0" style="text-align: right;" :total="total" :page.sync="queryInfo.pageNum"
			:limit.sync="queryInfo.pageSize" @pagination="loadData" />
	</u-dialog>
</template>

<script>
import qs from "qs";
import { formatDate } from "@/plugins/date.js";
import pagination from "../../../common/pagination";
export default {
	components: {
		pagination,
	},
	props: {
		visible: Boolean,
	},
	watch: {
		visible(val) {
			this.myVisible = val;
            if(val) {
        		this.loadData();
            }
		},
		myVisible(val) {
			this.$emit("update:visible", val);
		},
	},
	data() {
		return {
            loading: false,
			//用于获取数据列表
			queryInfo: {
				id: localStorage.roleId,
				me: 1,
				projectName: "",
				pageNum: 0,
				pageSize: 10,
			},
			myVisible: false,
			dataList: [],
			currentRow: {},
			total: 0,
		};
	},
	methods: {
        formatDate(time) {
            var date = new Date(time);
            return formatDate(date, "yyyy-MM-dd hh:mm:ss");
        },
		// 数据加载(项目列表)
		async loadData() {
			this.loading = true;
			const { data: res } = await this.$http.post(
				"/project/list?" + qs.stringify(this.queryInfo)
			);
			this.$nextTick(() => {
				this.loading = false;
			});
			if (!res.success) {
				return this.$message.error(res.message);
			}
            res.result.data.forEach(item => {
                item.timeStr = this.formatDate(item.createTime)
            })
			this.dataList = res.result.data;
			this.total = res.result.total;
		},
		rowClick(row) {
			this.currentRow = row;
		},
		confirm() {
            if(!this.currentRow) {
                this.$message.warning(this.$t('project.txt5'));
                return 
            }
			this.$emit("success", this.currentRow);
		},
	},
	mounted() {
	},
};
</script>

<style lang="less" scoped>
/deep/ .el-radio__label{
    display: none
}
</style>